module.exports = __webpack_public_path__ + "static/media/usgold-header-bg-lg-v03.2d1daeb6.jpg";